export default __webpack_public_path__ + "static/media/pattern03.a4fe6810.svg";